/* eslint-disable */
export default {
  to: 'Versenden an:',
  enterNameOrPhoneNumber: 'Nummer eingeben',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
